var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _line, _rect2, _line2, _rect3, _line3, _rect4, _path10, _path11, _rect5, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailingSuccessPreviw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 260,
    viewBox: "0 0 301 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.231 48.9257C167.751 56.6095 163.63 97.0756 185.54 108.596C214.755 123.956 270.393 89.7206 281.265 120.975C292.017 151.885 228.593 159.296 213.221 188.172C202.351 208.591 228.116 242.182 209.481 255.822C190.859 269.453 166.093 245.995 144.231 238.67C130.084 233.929 118.803 224.711 104.453 220.63C77.7087 213.023 40.2803 227.755 24.6724 204.666C10.49 183.685 36.1161 157.005 45.5426 133.482C54.2025 111.872 59.6879 88.3684 77.3372 73.2466C95.828 57.4037 121.114 41.3735 144.231 48.9257Z",
    fill: "#005ECE",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.129 140.879C292.17 140.879 289.772 138.481 289.772 135.523C289.772 132.564 292.17 130.166 295.129 130.166C298.087 130.166 300.485 132.564 300.485 135.523C300.485 138.481 298.087 140.879 295.129 140.879Z",
    fill: "#898D9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1522 10.7132C67.1938 10.7132 64.7956 8.31497 64.7956 5.3566C64.7956 2.39823 67.1938 0 70.1522 0C73.1106 0 75.5088 2.39823 75.5088 5.3566C75.5088 8.31497 73.1106 10.7132 70.1522 10.7132Z",
    fill: "#898D9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.278 111.424C236.278 112.785 241.659 114.419 243.274 116.596C244.888 118.774 246.503 123.13 247.848 123.13C249.193 123.13 250.808 118.774 252.422 116.596C254.037 114.419 259.418 112.785 259.418 111.424C259.418 110.063 255.651 109.246 252.691 106.796C249.732 104.346 249.462 99.9902 247.848 99.9902C246.234 99.9902 245.965 104.346 243.005 106.796C240.045 109.246 236.278 110.063 236.278 111.424Z",
    fill: "#898D9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.067 79.3829C204.067 80.1181 206.973 81.0004 207.845 82.1767C208.717 83.3531 209.589 85.7058 210.316 85.7058C211.043 85.7058 211.915 83.3531 212.787 82.1767C213.659 81.0004 216.565 80.1181 216.565 79.3829C216.565 78.6477 214.531 78.2065 212.932 76.8831C211.333 75.5597 211.188 73.207 210.316 73.207C209.444 73.207 209.299 75.5597 207.7 76.8831C206.101 78.2065 204.067 78.6477 204.067 79.3829Z",
    fill: "#898D9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.706 55.1721C243.282 55.1721 238.885 50.7754 238.885 45.3517C238.885 39.928 243.282 35.5312 248.706 35.5312C254.13 35.5312 258.526 39.928 258.526 45.3517C258.526 50.7754 254.13 55.1721 248.706 55.1721Z",
    fill: "#898D9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3309 76.5999C54.9073 76.5999 50.5105 72.2031 50.5105 66.7794C50.5105 61.3557 54.9073 56.959 60.3309 56.959C65.7546 56.959 70.1514 61.3557 70.1514 66.7794C70.1514 72.2031 65.7546 76.5999 60.3309 76.5999Z",
    fill: "#898D9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.446 77.4144C105.481 76.5069 104.306 75.8608 103.029 75.5358C102.205 75.3331 101.353 75.2718 100.509 75.3545C100.509 75.1375 100.507 74.9202 100.503 74.7027C102.029 74.7172 103.533 74.3325 104.869 73.586C106.018 72.9285 106.965 71.962 107.606 70.7934C108.269 69.6829 108.692 68.443 108.848 67.155C108.92 66.7947 108.986 66.4304 109.047 66.0645C109.204 66.0763 109.36 66.089 109.521 66.0953C109.933 70.6778 113.569 74.9331 118.025 74.4967L118.069 74.5054C118.164 74.526 118.262 74.5371 118.358 74.553C118.348 74.7312 118.337 74.9094 118.326 75.0884C117.114 75.1729 115.931 75.5032 114.848 76.0597C113.764 76.6161 112.802 77.3873 112.019 78.3276C110.701 79.8923 109.928 81.8522 109.818 83.9055C109.692 83.9158 109.566 83.9174 109.44 83.9198C109.403 82.689 109.119 81.4786 108.606 80.3622C108.134 79.2158 107.393 78.2038 106.446 77.4144Z",
    fill: "#898D9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0241 125.293C8.48069 123.841 6.60026 122.807 4.55715 122.287C3.23831 121.963 1.87508 121.865 0.524197 121.997C0.524197 121.65 0.521278 121.302 0.515438 120.954C2.95676 120.977 5.36265 120.362 7.50022 119.167C9.33893 118.115 10.8546 116.569 11.8798 114.699C12.9403 112.922 13.6175 110.938 13.8669 108.878C13.9832 108.301 14.0883 107.718 14.1859 107.133C14.4362 107.152 14.6865 107.172 14.9442 107.182C15.6037 114.514 21.421 121.323 28.5509 120.624L28.621 120.638C28.7737 120.671 28.9301 120.689 29.084 120.714C29.0677 121 29.0489 121.285 29.0314 121.571C27.0924 121.706 25.2 122.235 23.4666 123.125C21.7333 124.015 20.1942 125.249 18.9409 126.754C16.8328 129.257 15.5956 132.393 15.4197 135.679C15.217 135.695 15.0156 135.698 14.8141 135.701C14.755 133.732 14.3012 131.795 13.4802 130.009C12.7255 128.175 11.5389 126.556 10.0241 125.293Z",
    fill: "#898D9A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.365,
    y: 112.731,
    width: 114.223,
    height: 118.579,
    rx: 9.25,
    transform: "rotate(-11.0294 81.365 112.731)",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 84.1505,
    y1: 130.944,
    x2: 197.736,
    y2: 108.804,
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.802731,
    y: 0.693269,
    width: 114.223,
    height: 118.579,
    rx: 9.25,
    transform: "matrix(-0.997334 -0.0729749 -0.0729749 0.997334 220.842 102.744)",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 115.723,
    y2: -0.75,
    transform: "matrix(-0.997334 -0.0729749 -0.0729749 0.997334 220.941 122.656)",
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85.9541,
    y: 104.115,
    width: 114.223,
    height: 118.579,
    rx: 9.25,
    transform: "rotate(-4.18487 85.9541 104.115)",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 86.5498,
    y1: 122.529,
    x2: 201.965,
    y2: 114.084,
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9668,
    y: 101.639,
    width: 114.223,
    height: 118.579,
    rx: 9.25,
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.693 159.065L132.698 159.074L132.702 159.082L146.262 184.536L146.857 185.653L147.551 184.594L181.958 132.108L188.824 131.754L188.834 131.753L188.843 131.753C189.055 131.736 189.296 131.8 189.525 131.943L198.285 137.91L198.291 137.914C198.778 138.239 198.916 138.923 198.58 139.426L198.576 139.433L156.5 204.25H141.681L122.374 162.443L124.979 158.649L131.724 158.484C132.141 158.487 132.519 158.717 132.693 159.065Z",
    fill: "#E86E4D",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.223 190.92L140.654 189.76L125.826 159.515L125.826 159.514C125.507 158.863 124.727 158.584 124.066 158.882L124.063 158.883L115.06 162.891L115.055 162.893L115.055 162.893C114.383 163.187 114.082 163.969 114.379 164.641C114.38 164.642 114.38 164.643 114.381 164.645L132.618 204.25H148.71L190.544 140.307C190.943 139.694 190.788 138.915 190.184 138.497L141.223 190.92ZM141.223 190.92L141.948 189.851L180.327 133.34C180.327 133.339 180.327 133.339 180.327 133.339C180.749 132.723 181.62 132.57 182.209 132.977L182.209 132.978L190.184 138.496L141.223 190.92Z",
    fill: "#FF7F5D",
    stroke: "#050C26",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 140.524,
    y: 107.732,
    width: 31.1084,
    height: 6.16009,
    rx: 3.08004,
    fill: "#050C26"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 98.2168,
    y1: 120.049,
    x2: 213.94,
    y2: 120.049,
    stroke: "#050C26",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailingSuccessPreviw);
export default __webpack_public_path__ + "static/media/mailing-success-previw.a998bd8f8168bd22627461d099a0c326.svg";
export { ForwardRef as ReactComponent };